import React, { ChangeEvent, useState } from 'react'

import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import type { TSavedDashboardFilterDto } from '@homepal/api-contract'
import { useTranslation } from 'language/translator'

interface EditSavedUserFilterDialogProps {
  filter: TSavedDashboardFilterDto
  onClose: () => void
  onSave: (value: string) => void
  open: boolean
}

const EditSavedUserFilterDialog = (props: EditSavedUserFilterDialogProps) => {
  const { filter, onClose, onSave, open } = props

  const { t } = useTranslation()

  const [title, setTitle] = useState<string>(filter.title)

  return (
    <SimpleDialog
      title={t('global', 'change_name')}
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            {t('global', 'cancel')}
          </Button>
          <Button
            disabled={!title}
            onClick={() => {
              onSave(title)
              onClose()
            }}
            variant="contained"
          >
            {t('global', 'save')}
          </Button>
        </>
      }
    >
      <TextField
        fullWidth
        label={t('global', 'name')}
        onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
          setTitle(event.target.value)
        }}
        value={title}
      />
    </SimpleDialog>
  )
}

export default EditSavedUserFilterDialog
